import React from "react";
import { AlertTriangle } from "lucide-react";

// Iter99 — Phase 2C: generic reusable confirm dialog, same visual
// contract as Phase 2B's PlanificationToolSwitchConfirm.jsx (left
// untouched to avoid any regression risk on an already-validated
// component) — used here for delete-object, clear-all-drawings, and the
// unsaved-work navigation guard (spec §5.4/§8.2/§8.5).
export const PlanificationConfirmDialog = ({
  testId, title, message, confirmLabel, cancelLabel, onConfirm, onCancel, danger = false,
}) => (
  <div
    className="fixed inset-0 z-[490] flex items-end sm:items-center justify-center bg-black/50 p-4"
    data-testid={`${testId}-backdrop`}
    onClick={onCancel}
  >
    <div
      className="w-full sm:w-auto sm:min-w-[22rem] bg-[#111418] border border-zinc-700 p-4 flex flex-col gap-3"
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={`flex items-center gap-2 ${danger ? "text-red-400" : "text-amber-400"}`}>
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span className="text-sm font-semibold">{title}</span>
      </div>
      <p className="text-xs text-zinc-400">{message}</p>
      <div className="flex items-center justify-end gap-2 pt-1">
        <button
          type="button"
          data-testid={`${testId}-cancel-btn`}
          onClick={onCancel}
          className="px-3 py-1.5 text-xs font-medium text-zinc-300 hover:text-white border border-zinc-700 hover:border-zinc-500 transition-colors"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          data-testid={`${testId}-confirm-btn`}
          onClick={onConfirm}
          className={`px-3 py-1.5 text-xs font-semibold transition-colors ${
            danger ? "text-white bg-red-500 hover:bg-red-400" : "text-black bg-amber-400 hover:bg-amber-300"
          }`}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);
